export default __webpack_public_path__ + "static/media/sm1.574fca27.png";